var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
export function histogramBins(data, binCount) {
    var e_1, _a;
    if (binCount === void 0) { binCount = 10; }
    if (!data.length)
        return [];
    var min = Math.min.apply(Math, __spreadArray([], __read(data), false));
    var max = Math.max.apply(Math, __spreadArray([], __read(data), false));
    var span = max - min || 1;
    var step = span / binCount;
    var bins = Array.from({ length: binCount }, function (_, i) { return ({
        x0: min + i * step,
        x1: min + (i + 1) * step,
        count: 0,
    }); });
    try {
        for (var data_1 = __values(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()) {
            var v = data_1_1.value;
            var idx = Math.min(binCount - 1, Math.floor((v - min) / step));
            bins[idx].count++;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return bins;
}
export function quantile(sorted, p) {
    if (!sorted.length)
        return 0;
    var pos = (sorted.length - 1) * p;
    var base = Math.floor(pos);
    var rest = pos - base;
    if (sorted[base + 1] !== undefined) {
        return sorted[base] + rest * (sorted[base + 1] - sorted[base]);
    }
    return sorted[base];
}
export function boxStats(values) {
    var _a, _b;
    var sorted = __spreadArray([], __read(values), false).sort(function (a, b) { return a - b; });
    return {
        min: (_a = sorted[0]) !== null && _a !== void 0 ? _a : 0,
        q1: quantile(sorted, 0.25),
        median: quantile(sorted, 0.5),
        q3: quantile(sorted, 0.75),
        max: (_b = sorted[sorted.length - 1]) !== null && _b !== void 0 ? _b : 0,
    };
}
/** Simple Gaussian KDE samples */
export function kdeSamples(data, points, bandwidth) {
    if (!data.length)
        return points.map(function () { return 0; });
    var n = data.length;
    var h = bandwidth !== null && bandwidth !== void 0 ? bandwidth : (1.06 * stddev(data) * Math.pow(n, -0.2) || 1);
    return points.map(function (x) {
        var e_2, _a;
        var sum = 0;
        try {
            for (var data_2 = __values(data), data_2_1 = data_2.next(); !data_2_1.done; data_2_1 = data_2.next()) {
                var d = data_2_1.value;
                var z = (x - d) / h;
                sum += Math.exp(-0.5 * z * z) / Math.sqrt(2 * Math.PI);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (data_2_1 && !data_2_1.done && (_a = data_2.return)) _a.call(data_2);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return sum / (n * h);
    });
}
function stddev(data) {
    var mean = data.reduce(function (a, b) { return a + b; }, 0) / data.length;
    var v = data.reduce(function (a, b) { return a + Math.pow((b - mean), 2); }, 0) / data.length;
    return Math.sqrt(v);
}
export function normalQuantiles(n) {
    return Array.from({ length: n }, function (_, i) {
        var p = (i + 0.5) / n;
        return Math.sqrt(2) * inverseErf(2 * p - 1);
    });
}
function inverseErf(x) {
    var a = 0.147;
    var ln = Math.log(1 - x * x);
    var s = Math.sign(x);
    var t = 2 / (Math.PI * a) + ln / 2;
    return s * Math.sqrt(Math.sqrt(t * t - ln / a) - t);
}
export function hexbinCenters(points, _width, _height, radius) {
    var e_3, _a;
    var bins = new Map();
    var dx = radius * 1.5;
    var dy = radius * Math.sqrt(3);
    try {
        for (var points_1 = __values(points), points_1_1 = points_1.next(); !points_1_1.done; points_1_1 = points_1.next()) {
            var _b = __read(points_1_1.value, 2), px = _b[0], py = _b[1];
            var col = Math.round(px / dx);
            var row = Math.round(py / dy);
            var cx = col * dx;
            var cy = row * dy + (col % 2 ? dy / 2 : 0);
            var key = "".concat(col, ",").concat(row);
            var existing = bins.get(key);
            if (existing)
                existing.count++;
            else
                bins.set(key, { x: cx, y: cy, count: 1 });
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (points_1_1 && !points_1_1.done && (_a = points_1.return)) _a.call(points_1);
        }
        finally { if (e_3) throw e_3.error; }
    }
    return bins;
}
